<template lang="pug">
  .dt--list-item--color
    .name.f-title Color Name
    .preview.radius-l.shadow-card.ani-fast.pointer
  //- .dt-thumbnail.radius-m.shadow-card.pointer.ani-fast()
    slot
      //- default thumbnail
      .default
        .name.f-title {{key}}
        .value.f-p {{value}}
</template>
<style lang="stylus" scoped>
@require '../../styles/layout/main'
@require '../../styles/design/main'

.dt--list-item--color
  stack(y, gap: 1rem)

.preview
  background white
  height 12rem

.dt-thumbnail
  background var(--clr-bg)

.default
  stack(y, gap: .25rem)
  padding 1rem
.name
  color var(--clr-content-2)
  // padding 0 .5rem
.value
  color var(--clr-content-3)
</style>
<script>
export default {
  props: {
    key: {
      type: String,
      default: "{{DesignToken.name}}"
    },
    value: {
      type: String,
      default: "{{DesignToken.value}}"
    }
  }
};
</script>
